import { useMemo } from 'react';
import { BLANK_OPTION } from '~/constants/dropdowns/BlankOption';

export const useEnhancedOptions = (options, addBlank) =>
  useMemo(() => {
    if (!addBlank) {
      return options;
    }
    return [BLANK_OPTION, ...(options || [])];
  }, [options, addBlank]);
